const API_KEY = process.env.REACT_APP_GOOGLE_MAP_KEY;

export const map_settings = {
    ftm_map_icon: "/assets/img/ftm-map.png",
    loading_map_icon: '/assets/img/job_loading.gif',
    customer_map_icon: `/assets/img/customer-v1.png`,
    car_map_icon: `/assets/img/car.png`,
    map_script_url: `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&libraries=places,marker`
}